import useSelectedDateRange from 'components/roster-portal/activity-planning/hooks/useSelectedDateRange';
import { omit } from 'lodash-es';
import { useMemo, useEffect } from 'react';
import { useShallow } from 'zustand/shallow';
import { useMrpWebSocket } from '../hooks/useMrpWebSocket';
import { useEntityStore } from '../stores/entityStore/entityStore';
import { useSelector } from 'react-redux';
import { useAppointmentStore } from '../stores/appointmentStore/appointmentStore';

export const useRefetchPlanningOnEntityChange = () => {
  const { startDate, endDate } = useSelectedDateRange();
  const { hasHydrated, refetchPlanning, subscribers } = useEntityStore(
    useShallow((state) => ({
      hasHydrated: state.hasHydrated,
      refetchPlanning: state.control.fetch,
      subscribers: state.subscribers
    }))
  );

  const stableSubscribers = useMemo(
    () => subscribers.map((s) => omit(s, 'isError', 'isLoading')),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [subscribers.map((s) => `${s.planningEntityType}:${s.entityId}`).join('|')]
  );

  useEffect(() => {
    if (stableSubscribers.length === 0 || !startDate || !endDate) return;
    refetchPlanning({
      planningEntityIdentifiers: stableSubscribers,
      startDate,
      endDate
    });
  }, [startDate, endDate, hasHydrated, stableSubscribers, refetchPlanning]);

  useMrpWebSocket();

  const hasAddAppointmentAccess = useSelector(
    ({ grants }) => grants.hasAddAppointmentAccess
  );
  const appointment = useAppointmentStore(
    useShallow((state) => state.appointment)
  );

  return { hasAddAppointmentAccess, appointment };
};
